import { useState, useEffect, useContext, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { SessionContext } from "../context/SessionContext";
import { ProfileContext } from "../context/ProfileContext";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import toast from "react-hot-toast";
import AnnouncementDetails from "../components/AnnouncementDetails";
import ToastDisplay from "../components/ToastDisplay";
import AnnouncementRecipients from "../components/AnnouncementRecipients";

const Announcement = () => {
	let { id } = useParams();
	const navigate = useNavigate();
	const photoRef = useRef(null);
	const [session] = useContext(SessionContext);
	const [profile] = useContext(ProfileContext);
	const [loading, setLoading] = useState(true);
	const [announcement, setAnnouncement] = useState(null);
	const [actionLoading, setActionLoading] = useState(false);
	const [tab, setTab] = useState("details");

	const getData = async () => {
		setLoading(true);
		const requestOptions = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				"X-Auth-Token": session,
			},
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/announcements/a/${id}`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			toast(<ToastDisplay status="error" content="Something went wrong." />);
		} else {
			setAnnouncement(data.announcement);
		}
		setLoading(false);
	};

	useEffect(() => {
		if (profile) {
			if (!profile.role.announcements_view) {
				navigate("/");
			} else {
				if (id) {
					getData();
				}
			}
		}
	}, [id, profile]);

	return (
		<>
			<Container className="gx-5">
				<div className="info-page-header mb-10">
					<a
						href="#"
						className="back-btn flex-row-left fit mb-20"
						onClick={(e) => {
							e.preventDefault();
							navigate(-1);
						}}
					>
						<i className="ri-arrow-left-line opacity-7" />
						<span className="text-sm text-regular-inter upper opacity-7">
							Announcements
						</span>
					</a>
					<Row className="flex-row-left mb-30">
						<Col className="flex-row-left">
							<h1 className="text-lg mb-0 text-medium-gotham">
								Announcement Details
							</h1>
						</Col>
					</Row>
				</div>
				<Nav variant="tabs" defaultActiveKey={tab} className="mb-20">
					<Nav.Item>
						<Nav.Link
							eventKey="details"
							className="info-tab-item"
							onClick={() => setTab("details")}
						>
							Details
						</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link
							eventKey="recipients"
							className="info-tab-item"
							onClick={() => setTab("recipients")}
						>
							Recipients
						</Nav.Link>
					</Nav.Item>
				</Nav>
				{tab === "details" && (
					<AnnouncementDetails loading={loading} announcement={announcement} />
				)}
				{tab === "recipients" && (
					<AnnouncementRecipients announcement={announcement} />
				)}
			</Container>
		</>
	);
};

export default Announcement;
